import RealEstateModuleHost from "../../pages/realestate/RealEstateModuleHost";

const route = {
  key: "realestateHost",
  path: "/realestate/*",
  component: RealEstateModuleHost,
  permission: "REALESTATE_PROPERTY_READ",
  private: true,
  layout: "main",
  icon: "faBuilding",
  group: "realestate",
  order: 35
};

export default route;
